import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789/—";
const FRAMES = 22;

export const ScrambleText = ({ text }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(text);

  useEffect(() => {
    if (!inView) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setDisplay(text);
      return;
    }
    let frame = 0;
    const interval = setInterval(() => {
      frame += 1;
      const settled = Math.floor((frame / FRAMES) * text.length);
      let out = "";
      for (let i = 0; i < text.length; i++) {
        out += text[i] === " " || i < settled ? text[i] : CHARS[Math.floor(Math.random() * CHARS.length)];
      }
      setDisplay(out);
      if (frame >= FRAMES) {
        setDisplay(text);
        clearInterval(interval);
      }
    }, 38);
    return () => clearInterval(interval);
  }, [inView, text]);

  return <span ref={ref}>{display}</span>;
};
